import { render, staticRenderFns } from "./flex-placeholder.vue?vue&type=template&id=fa0dff4e&"
import script from "./flex-placeholder.vue?vue&type=script&lang=js&"
export * from "./flex-placeholder.vue?vue&type=script&lang=js&"
import style0 from "./flex-placeholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports